'use strict';

angular.module('core').controller('AccountLockedWarningController', ['$scope', '$rootScope', 'Authentication', 'EntryMain', 'Teams', '$stateParams',
	function($scope, $rootScope, Authentication, EntryMain, Teams, $stateParams) {
		$scope.authentication = Authentication;
		$scope.headline = '';
		$scope.warningVisible = false;
		$scope.stateHideMe = false;

		// States in which we do not want to display the account locked warning
		var hideStates = [
			'accountLocked',
			'docs',
			'faq'
		];

		// The different headlines
		var headlines = {
			'current': 'Your account is locked',
			'app': 'App owner is locked',
			'team': 'Team owner is locked'
		};


		/**
		 * Hides/Shows the warning according to the current state
		 */
		$scope.setPageVisibility = function(stateName) {
			if (hideStates.indexOf(stateName) !== -1) {
				$scope.stateHideMe = true;
			} else {
				$scope.stateHideMe = false;
			}
		};


		/**
		 * Initializes the data to display depending on the current state
		 */
		$scope.init = function() {
			$scope.warningVisible = false;

			if ($stateParams.mobileAppId) {
				// Check the app owner
				EntryMain._fetchMobileApp($stateParams.mobileAppId, false, function(err, mobileApp) {
					if (!err) {
						if (mobileApp.user && mobileApp.user.accountLocked === true) {
							if (mobileApp.user._id === $scope.authentication.user._id) {
								$scope.headline = headlines.current;
							} else {
								$scope.headline = headlines.app;
							}

							$scope.warningVisible = true;
						}
					}
				});
			} else if ($stateParams.teamId) {
				// Check the team owner
				Teams.get({
					teamId: $stateParams.teamId
				},function(team) {
					if (team.user && team.user.accountLocked === true) {
						if (team.user._id === $scope.authentication.user._id) {
							$scope.headline = headlines.current;
						} else {
							$scope.headline = headlines.team;
						}
						$scope.warningVisible = true;
					}
				});
			} else {
				// Check the current user
				if ($scope.authentication.user && $scope.authentication.user.accountLocked) {
					$scope.headline = headlines.current;
					$scope.warningVisible = true;
				}
			}
		};


		// Update the data on every state change because depending on the state
		// different warnings have to get displayed
		$rootScope.$on('$stateChangeSuccess', function(event, toState) {
			$scope.init();
			$scope.setPageVisibility(toState.name);
		});

	}
]);
